import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    footerContainer: {
        justifyContent: "flex-end",
        width: "100%"
    },
    formContainer: {
        flexDirection: "column"
    },
    container: {
        width: "100%",
        maxWidth: 600
    }
});

export default stylesheet;
